import * as React from 'react';
import * as _ from 'lodash';
import { IArticleListItem } from '../shared/shared-types';
import { ArticleListItem } from '../shared/article-list-item';

export interface IArticleListProps {
    isLoading: boolean,    
    articles: Array<IArticleListItem>,
    noResultMessage: string,
}

export class ArticleList extends React.Component<IArticleListProps, {}>{
    render() {

        const className = 'article-list';
        if (this.props.isLoading) {

            return (
                <div className={className}>
                    <p>Loading...</p>
                </div>
            );

        } else if (this.props.articles.length) {

            return (
                <div className={className}>
                    {this.props.articles.map(x => <ArticleListItem key={`${x.id}:${x.language}`} item={x} />)}
                </div>
            );

        } else if (!_.isNil(this.props.noResultMessage)) {

            return (
                <div className={className}>
                    <p>{this.props.noResultMessage}</p>
                </div>
            );

        }

    }
}


// WEBPACK FOOTER //
// ./~/source-map-loader!./app/src/shared/article-list.tsx